import { Container, ScrollView, shadowStandard } from '@my/ui'
import { MainLayout, Meta } from 'app/components'
import { ComingSoon } from 'app/components/coming-soon'

export const AccommodationScreen = () => {
  return (
    <MainLayout>
      <Meta title="Accommodation" />
      <ScrollView ai="center" jc="center">
        <Container size="sm" gutter mt="$3.5" bc="$white" {...shadowStandard}>
          <ComingSoon
            title='Coming soon!'
            description='Our Accommodation list will be released soon.'
          />
        </Container>
      </ScrollView>
    </MainLayout>
  )
}
